module.exports = __webpack_public_path__ + "static/media/Microsoft Surface Book.00289e78.png";